import { BoxIcon, Button, Text } from '#atoms';
// import { useUserInfo } from '#providers/UserInfo';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import {
  ButtonBox,
  CheckBox,
  ClinicalDataCard,
  ClinicalDataWrap,
  Container,
  Content,
  FilterBox,
  FilterItem,
  InfoBox,
  Label,
  LabelBox,
  LectureName,
  Line,
  MemberInfoWrap,
  MiddleWrap,
  NameWrap,
  Tags,
  TagsBox
} from './styles';
// import { useGetClinicalDataList } from '#api/clinical-data';
import { ReactNode, useEffect, useState } from 'react';
import { SortingOptions } from '#organisims/ClinicalSortingOptions';
import { Modal } from '#molecules';
import { ClinicalDataModal } from '#molecules/ClinicalDataModal';
import { ClinicalFilterSheet } from '#organisims/ClinicalFilterSheet';
import { useFilter } from '#organisims/ClinicalFilterSheet/Filter';

export interface ClinicalDataProps {
  isHighlight: boolean;
  lectureName: string;
  memberName: string;
  sex: string;
  age: number;
  startDate: string;
  endDate: string;
  rounds: number;
  registeredLectureId: string;
}

export interface FilterOptionProps {
  round: number;
  lectureName: number;
  sex: number;
  age: number;
}

export interface optionProps {
  option1: number;
  option2: number;
  option3: number;
  option4: number;
}

interface props {
  type?: 'default' | 'selected';
}

export const ClinicalDataList = ({ type = 'default' }: props) => {
  // const { userInfo } = useUserInfo();
  // const { data: clinicalData } = useGetClinicalDataList({
  //   coachId: userInfo?.id ?? '',
  //   offset: 20
  // });
  const [isModal, setIsModal] = useState(false);
  //데이터 리스트

  const [modalComponent, setModalComponent] = useState<ReactNode>(null);
  const [isSelectedOption, setIsSelectedOption] = useState('최근 수업 순');

  const [isOpenFilter, setIsOpenFilter] = useState(false);

  const [isCheckData, setIsCheckData] = useState<ClinicalDataProps>();

  const [filterOption, setFilterOption] = useState<FilterOptionProps>({
    round: 0,
    lectureName: 0,
    sex: 0,
    age: 0
  });
  const dummyData: ClinicalDataProps[] = [
    {
      isHighlight: true,
      lectureName: '다이어트',
      memberName: '최윤호',
      sex: '남성',
      age: 22,
      startDate: '2023.11.20',
      endDate: '2023.12.19',
      rounds: 15,
      registeredLectureId: ''
    },
    {
      isHighlight: false,
      lectureName: '다이어트',
      memberName: '최윤호',
      sex: '남성',
      age: 31,
      startDate: '2023.11.20',
      endDate: '2023.12.19',
      rounds: 30,
      registeredLectureId: ''
    },
    {
      isHighlight: true,
      lectureName: '재활운동',
      memberName: '최윤호',
      sex: '여성',
      age: 15,
      startDate: '2023.11.20',
      endDate: '2023.12.19',
      rounds: 10,
      registeredLectureId: ''
    },
    {
      isHighlight: false,
      lectureName: '다이어트',
      memberName: '최윤호',
      sex: '여성',
      age: 18,
      startDate: '2023.11.20',
      endDate: '2023.12.19',
      rounds: 20,
      registeredLectureId: ''
    },
    {
      isHighlight: true,
      lectureName: '체형교정',
      memberName: '최윤호',
      sex: '여성',
      age: 52,
      startDate: '2023.11.20',
      endDate: '2023.12.19',
      rounds: 30,
      registeredLectureId: ''
    },
    {
      isHighlight: false,
      lectureName: '바디프로필',
      memberName: '최윤호',
      sex: '남성',
      age: 24,
      startDate: '2023.11.20',
      endDate: '2023.12.19',
      rounds: 20,
      registeredLectureId: ''
    }
  ];
  const [clinicalList, setClinicalList] = useState(
    useFilter({ dummyData, filterOption })
  );
  const clickHandlerSort = (option: string) => {
    setIsSelectedOption(option);
  };

  const clickHandlerModal = (type: number) => {
    type === 0
      ? setModalComponent(
          <SortingOptions
            isSelectedOption={isSelectedOption}
            clickHandlerSort={clickHandlerSort}
            onClose={onClose}
          />
        )
      : setModalComponent(<ClinicalDataModal onClose={onClose} />);
    setIsModal(true);
  };

  const onClose = () => {
    setIsModal(false);
  };
  const onCloseFilter = () => {
    setIsOpenFilter(false);
  };

  const clickHandlerFilter = ({
    option1,
    option2,
    option3,
    option4
  }: optionProps) => {
    setFilterOption({
      round: option1,
      lectureName: option2,
      sex: option3,
      age: option4
    });
  };

  useEffect(() => {
    if (!isModal) {
      document.body.style.overflow = 'hidden';
    }
  }, [isModal]);
  useEffect(() => {
    setClinicalList(useFilter({ dummyData, filterOption }));
  }, [filterOption]);
  return (
    <>
      <PrevHeaderBarWithTitleTemplate
        title={type === 'default' ? '임상 데이터' : ''}
        headerbarStyle={{ backgroundColor: '#18171c', zIndex: 30 }}
      >
        <Container>
          {type === 'default' ? (
            ''
          ) : (
            <Text textStyle="t1" style={{ margin: '2rem 0 4rem 0' }}>
              트레이닝 성과를 생성할 <br /> 운동차트를 선택해 주세요
            </Text>
          )}
          <MiddleWrap>
            <Text>총 {clinicalList.length}개</Text>
            <FilterBox>
              <FilterItem onClick={() => clickHandlerModal(0)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M8 4L5.33333 1.33333L2.66667 4L4.66667 4L4.66667 14L6 14L6 4L8 4Z"
                    fill="#8E899F"
                  />
                  <path
                    d="M8 12L10.6667 14.6667L13.3333 12L11.3333 12L11.3333 2L10 2L10 12L8 12Z"
                    fill="#8E899F"
                  />
                </svg>
                <Text style={{ fontSize: '1.3rem', lineHeight: '1.8rem' }}>
                  정렬
                </Text>
              </FilterItem>
              <FilterItem onClick={() => setIsOpenFilter(!isOpenFilter)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M2 2.66667C3.34 4.39333 6.66667 8.66667 6.66667 8.66667V13.3333H9.33333V8.66667C9.33333 8.66667 12.6533 4.39333 14 2.66667H2Z"
                    fill="#5C576B"
                  />
                </svg>
                <Text style={{ fontSize: '1.3rem', lineHeight: '1.8rem' }}>
                  필터
                </Text>
              </FilterItem>
            </FilterBox>
          </MiddleWrap>
          {!isOpenFilter && (
            <ClinicalDataWrap>
              {clinicalList.map((data, idx) => (
                <ClinicalDataCard key={idx}>
                  <TagsBox>
                    <Tags>
                      <LectureName>
                        <p style={{ color: '#9170f2' }}>{data.lectureName}</p>
                      </LectureName>
                    </Tags>
                    {type === 'default' ? (
                      <BoxIcon
                        type="dots_vertical_rounded"
                        boxColor="transparent"
                        size={16}
                        onlyIcon={true}
                        onClick={() => clickHandlerModal(1)}
                      />
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        onClick={() => {
                          if (isCheckData !== data) {
                            setIsCheckData(data);
                          } else {
                            setIsCheckData(undefined);
                          }
                        }}
                      >
                        <rect
                          width="18"
                          height="18"
                          fill={isCheckData === data ? '#7750E9' : '#383441'}
                          // fill="#383441"
                          rx="4"
                          ry="4"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.5 7.5L3 9L7.5 13.5L15 6L13.5 4.5L7.5 10.5L4.5 7.5Z"
                          fill={isCheckData === data ? 'white' : '#5C576B'}
                        />
                      </svg>
                    )}
                  </TagsBox>

                  <NameWrap>
                    <CheckBox />
                    <Text
                      style={{
                        fontSize: '1.6rem',
                        lineHeight: '2.1rem'
                      }}
                    >
                      {data.memberName} 회원
                    </Text>
                  </NameWrap>
                  <MemberInfoWrap>
                    <Line />
                    <InfoBox>
                      <LabelBox>
                        <Label>회원 정보</Label>
                        <Content>
                          {data.age}세 · {data.sex}
                        </Content>
                      </LabelBox>
                      <LabelBox>
                        <Label>수업 기간</Label>
                        <Content>
                          ({data.startDate} ~ {data.endDate})
                        </Content>
                      </LabelBox>
                      <LabelBox>
                        <Label>수업 횟수</Label>
                        <Content>{data.rounds}회</Content>
                      </LabelBox>
                    </InfoBox>
                  </MemberInfoWrap>
                </ClinicalDataCard>
              ))}
            </ClinicalDataWrap>
          )}
        </Container>
        {isModal && <Modal onClose={onClose}>{modalComponent}</Modal>}
        {isOpenFilter && (
          <ClinicalFilterSheet
            filterOption={filterOption}
            isOpenFilter={isOpenFilter}
            clickHandlerFilter={clickHandlerFilter}
            onClose={onCloseFilter}
            data={dummyData}
            // setFilterOption={setFilterOption}
          />
        )}
        {type === 'default' ? (
          ''
        ) : (
          <ButtonBox>
            <Button disabled={isCheckData === undefined ? true : false}>
              확인
            </Button>
          </ButtonBox>
        )}
      </PrevHeaderBarWithTitleTemplate>
    </>
  );
};
